import { useCallback, useState } from 'react';
import api from '../lib/api';
import { getPublicApiBaseUrl } from '../lib/publicApiBase';

type UseOpenKanbanOptions = {
  onError?: (message: string) => void;
};

export function useOpenKanban(options?: UseOpenKanbanOptions) {
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState('');

  const openKanban = useCallback(async () => {
    setError('');
    setOpening(true);
    const tab = window.open('about:blank', '_blank');
    if (tab) {
      tab.opener = null;
    }
    try {
      const { data } = await api.get<{ eligible: boolean; error?: string }>('/auth/kanban/eligibility');
      if (!data.eligible) {
        tab?.close();
        const message = data.error || 'You cannot access Kanban with this account.';
        setError(message);
        options?.onError?.(message);
        return;
      }
      const base = getPublicApiBaseUrl();
      const path = '/api/auth/kanban/start';
      const destination = base ? `${base}${path}` : path;
      if (tab) {
        tab.location.href = destination;
      } else {
        window.open(destination, '_blank', 'noopener,noreferrer');
      }
    } catch (err: unknown) {
      tab?.close();
      const message =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ||
        'Could not start Kanban SSO.';
      setError(message);
      options?.onError?.(message);
    } finally {
      setOpening(false);
    }
  }, [options]);

  return { openKanban, opening, error };
}
